import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.togglePercentageInput();
  }

  updatePreview(event) {
    event.preventDefault();

    const percentageInput = document.querySelector(`#sample_percentage_${this.element.dataset.id}`);
    const percentage = percentageInput ? percentageInput.value : 10;
    const checkbox = document.querySelector(`#select_sample_${this.element.dataset.id}`);
    const isChecked = checkbox ? checkbox.checked : false;
    const orgId = this.element.dataset.id;

    let url = `${orgId}/update_sampling_parameters?sample_percentage=${percentage}&checked=${isChecked}`;

    fetch(url, { method: 'GET' })
      .then((response) => response.text())
      .then((html) => {
        const turboFrame = document.getElementById(
          `sampling_parameters_${this.element.dataset.id}`
        );
        turboFrame.innerHTML = html;

        const newCheckbox = turboFrame.querySelector(`#select_sample_${orgId}`);
        if (newCheckbox) newCheckbox.checked = isChecked;
      });
  }

  togglePercentageInput() {
    const checkbox = this.element.querySelector("input[type='checkbox']");
    const input = this.percentageTarget;

    if (checkbox && input) {
      input.disabled = !checkbox.checked;
    }
  }
}
